/**
 * Screen 13 — KYC verification.
 *
 * Phase 2 (identity verification) is intentionally deferred — see project
 * memory `project-triviana-phase-order`. This screen renders the wireframe
 * UI flow so deep links + the Profile shortcut don't 404, but the
 * underlying API + flow land in a later phase.
 */

import { auth } from '../auth.js';
import { toast } from '../components/toast.js';

const STEPS = [
  ['1', 'Personal details', 'Name, date of birth'],
  ['2', 'BVN / ID number',   'Validated instantly'],
  ['3', 'Selfie / liveness', 'Match to your ID'],
];

export function renderKyc(root) {
  const me = auth.getMe();
  // Mark step state. With KYC deferred, everyone is at the start.
  // Once kyc_level >= 2 lands we'll mark all done.
  const status = (i) => {
    if ((me?.kyc_level ?? 0) >= 2) return 'done';
    if (i === 0) return 'active';
    return 'todo';
  };

  root.innerHTML = `
    <div class="appbar">
      <a href="/profile" data-link class="appbar-back" aria-label="Back">‹</a>
      <div class="appbar-title">Verify your identity</div>
    </div>
    <div class="pad">
      <div style="font-size:12.5px;color:var(--mute);font-weight:500;margin:8px 0 16px;line-height:1.5;">
        Required once before you can play for cash or withdraw. Takes about 2 minutes.
      </div>

      ${STEPS.map((s, i) => {
        const st = status(i);
        return `
          <div class="card">
            <div class="row">
              <div class="ic ${st === 'done' ? 'teal' : st === 'active' ? 'violet' : ''}">
                ${st === 'done' ? '✓' : s[0]}
              </div>
              <div class="grow">
                <b style="font-size:13.5px;color:#fff;font-weight:600;">${s[1]}</b>
                <div style="font-size:11px;color:var(--mute);font-weight:500;">${s[2]}</div>
              </div>
              ${st === 'active' ? '<span class="tag vio">NOW</span>' : ''}
              ${st === 'done' ? '<span class="tag teal">DONE</span>' : ''}
            </div>
          </div>
        `;
      }).join('')}

      ${
        (me?.kyc_level ?? 0) >= 2
          ? `<div class="note teal">You are verified — paid contests + withdrawals are unlocked.</div>`
          : `<div class="note gold">
              KYC is launching soon. You can already play free games and 1-on-1 duels;
              paid contests + withdrawals will unlock once verification ships.
             </div>`
      }

      <button type="button" class="btn" id="kyc-start" ${(me?.kyc_level ?? 0) >= 2 ? 'disabled' : ''}>
        ${(me?.kyc_level ?? 0) >= 2 ? 'Already verified' : 'Start verification'}
      </button>
      <div class="center" style="font-size:11px;color:var(--mute);font-weight:500;">
        Encrypted · NDPR compliant · 18+ only
      </div>
    </div>
  `;

  document.getElementById('kyc-start')?.addEventListener('click', () => {
    toast.info('KYC verification launches in a future release.');
  });
}
